import Alpine from "../alpine";
import { insensitiveStringContains } from "../alpine/insensitiveStringContains";

Alpine.data("activityCategoryFilter", () => ({
  activitiesIdsSelectedStr: "",
  activitiesAll: [],
  activitiesFiltered: [],

  init: async function () {
    const activitiesJson = this.$el.dataset.activitiesJson;
    const nbrMaxActivity = parseInt(this.$el.dataset.nbrMaxActivity);

    this.activitiesAll = JSON.parse(activitiesJson);
    this.activitiesFiltered = this.activitiesAll;
    const { create } = await import("../framework/components/filter-toolbar");
    create("js-activities-filters", {
      storageKey: "js-activities-filters-" + window._current_academy_id,
    });
    // init activity selection store to prevent select more activities than the user can because of lms limitations
    Alpine.store("activitySelection").init(nbrMaxActivity);
  },

  canSelect: function (activityId) {
    return this.nbrMaxActivity > 0 || this.activitiesIdsSelected.includes(activityId);
  },

  onActivitySelectionChange: function (activityId) {
    const store = Alpine.store("activitySelection");
    const index = store.activitiesIdsSelected.indexOf(activityId);

    if (index === -1) {
      if (store.nbrMaxActivity <= 0) {
        return;
      }
      store.activitiesIdsSelected.push(activityId);
      store.nbrMaxActivity -= 1;
    } else {
      store.activitiesIdsSelected.splice(index, 1);
      store.nbrMaxActivity += 1;
    }

    this.activitiesIdsSelectedStr = JSON.stringify(store.activitiesIdsSelected);
  },

  onFiltersChanged: function (newFilters = {}) {
    const searchQuery = newFilters.search.trim();
    this.activitiesFiltered = this.activitiesAll.filter((activity) => {
      if (!searchQuery) return true;
      return insensitiveStringContains(activity.name, searchQuery) || insensitiveStringContains(activity.description, searchQuery);
    });
  },
  shouldShowActivity: function (id) {
    return this.activitiesFiltered.some((activity) => activity.id === id);
  },
  doFiltersUnmatch: function () {
    return this.activitiesFiltered.length === 0 && this.activitiesAll.length > 0;
  },
  doLimitNbrActivitiesReached: function () {
    const store = Alpine.store("activitySelection");
    return store.nbrMaxActivity <= 0;
  },
}));
